import { Map } from 'immutable';
import actions from './action';
/**
 * Things you should never do inside a reducer:
1. Mutate its arguments;
2. Perform side effects like API calls and routing transitions;
3. Call non-pure functions, e.g. Date.now() or Math.random().
 */


const initState = new Map({
  //AskDigit Pojo - copy from collection
  ask_digit: '',
  hotDeals: '',

  //Control form operations 
  success: false,
  msg: '',
  result: [],
  listresult: [],
  listsuccess: false,
  total_count: 0,
  page: 1,
});


export default function configReducer(state = initState, action) {
   switch (action.type) {
    case actions.CONFIG_READ_SUCCESS:
      return state
        .set('success', action.success)
        .set('msg', action.msg)
        .set('data', action.data)
        .set('totalCount', action.totalCount)
        .set('page',action.page);
    case actions.CONFIG_ADD_NEW:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    case actions.CONFIG_UPDATE:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    case actions.CONFIG_ADD_NUDGING:
      return state
        .set('success', action.success)
        .set('msg', action.msg);
    case actions.NUDGE_FETCH_LIST_ID:
      return state
        .set('success', action.success)
        .set('msg', action.msg)
        .set('data', action.data)
    default:
      return state;
  }
}
